import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Eyebrow } from './Eyebrow';
export function Faqs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="bg-paper-100 py-16 sm:py-24" data-id="element-83" data-mp="355wmre581tm1">
      <div className="mx-auto grid max-w-shell gap-8 px-5 sm:px-6 lg:grid-cols-[minmax(0,20rem)_minmax(0,1fr)] lg:gap-20" data-id="element-84" data-mp="357zj0fwywiz7">
        <div data-id="element-85" data-mp="3f3t5os4ehsup">
          <Eyebrow data-id="element-86" data-mp="3f39o5cinx6h7">Frequently asked questions</Eyebrow>
          <h2 id="faq-heading" className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-87" data-mp="3f65n9468y178">
            Before you decide
          </h2>
        </div>

        <div className="divide-y divide-paper-300 border-t border-paper-300" data-id="element-88" data-mp="1ppo1hfvnrkxi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-89" data-mp="2hbihqa0j8792" data-mpi={index}>
                <h3 data-id="element-90" data-mp="2hck5nf2nco87">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-91" data-mp="2hd1x7yed6e9s">
                    <span className="font-display text-lg leading-snug text-ink sm:text-2xl" data-id="element-92" data-mp="30a379xmrz4kl">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-brass transition-transform duration-150 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-93" data-mp="2vc1n19dm4z7j" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-94" data-mp="1eunpf3h1toj6">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-95" data-mp="1a01mlop194ap">
                      <p className="max-w-2xl pb-7 text-base leading-relaxed text-ink-soft" data-id="element-96" data-mp="3t6m5q7wgic1a">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}